export enum FilePreviewDisplayType {
	Image = 0,
	PDF = 1,
	Unsupported = 2,
	Converting = 3,
	SizeWarning = 4
}